// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isDefined = <T>(value: T | undefined | null): value is T =>
  value !== undefined && value !== null;

export default isDefined;
